import { Table } from "common/Table/Table";
import { formatPhone } from "pages/Contacts";
import {
  OFFICES_DEFAULT_PAGE_SIZE,
  officesPaginationState,
  resolveOfficesFetchParams,
} from "pages/offices/officePagination";
import { Fragment, useEffect, useState } from "react";
import UserService from "services/user.service";
import { exportToCSV } from "utils/funcs";

const service = new UserService();

export const Sales = () => {
  const columns = [
    {
      key: "office_name",
      title: "office name",
      dbColName: "office_name",
      freeze: true,
      freezeIndex: "left-0",
    },
    {
      key: "office_type",
      title: "office type",
      dbColName: "office_type",
      freeze: true,
      freezeIndex: "left-40",
    },
    {
      key: "management_group_leader_name",
      dbColName: "management_group_leader_name",
       title: "management group leader name",
    },
    {
      key: "management_group_leader_id",
       dbColName: "management_group_leader_id",
       title: "management group leader id",
    },
    {
      key: "management_group_leader_phone",
       dbColName: "management_group_leader_phone",
       title: "management group leader phone",
      render: phone => formatPhone(phone)
    },
    {
      key: "senior_management_group_leader_name",
      title: "senior management group leader name",
      dbColName: "senior_management_group_leader_name",
    },
    {
      key: "senior_management_group_leader_id",
      title: "senior management group leader id",
      dbColName: "senior_management_group_leader_id",
    },
    {
      key: "senior_management_group_leader_phone",
      title: "senior management group leader phone",
      dbColName: "senior_management_group_leader_phone",
      render: phone => formatPhone(phone)
    },
    {
      key: "region_leader_name",
      title: "region leader name",
      dbColName: "region_leader_name",
    },
    {
      key: "region_leader_id",
      title: "region leader id",
      dbColName: "region_leader_id",
    },
    {
      key: "region_leader_phone",
      title: "region leader phone",
      dbColName: "region_leader_phone",
      render: phone => formatPhone(phone)

    },
    {
      key: "senior_region_leader_name",
      dbColName: "senior_region_leader_name",
      title : "senior region leader name",
    },
    {
      key: "senior_region_leader_id",
      dbColName: "senior_region_leader_id",
       title : "senior region leader id",
    },
    {
      key: "senior_region_leader_phone",
      dbColName : "senior_region_leader_phone",
      title : "senior region leader phone",
      render: phone => formatPhone(phone)
      
    },
    {
      key: "partnership_leader_name",
      dbColName: "partnership_leader_name",
      title: "partnership leader name",
    },
    {
      key: "partnership_leader_id",
      dbColName : "partnership_leader_id",
      title: "partnership leader id",
    },
    {
      key: "partnership_leader_phone",
      dbColName: "partnership_leader_phone",
      title : "partnership leader phone",
      render: phone => formatPhone(phone)
    },
    {
      key: "division_name",
      title: "division name",
      dbColName: "division_name",
    },
  ];

  const [data, setData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState(() =>
    officesPaginationState(OFFICES_DEFAULT_PAGE_SIZE)
  );

  useEffect(() => {
    setLoading(true);
    const fetchParams = resolveOfficesFetchParams(pagination);
    service
      .getSaleOffices(fetchParams)
      .then((resp) => {
        setTotalItems(+resp.data.total_docs);
        setData(resp.data.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [pagination]);

  const handleExport = () => {
    exportToCSV(data, "sales");
  };

  return (
    <Fragment>
      <div className="flex flex-col mb-4">
        <h1 className="font-semibold text-gray-700 tracking-wide text-xl">
          Sales
        </h1>
        <p className="page-subtitle">View all offices </p>
      </div>
      <Table
        data={data}
        pagination={pagination}
        handleExport={handleExport}
        setPagination={setPagination}
        loadingData={loading}
        filters={null}
        totalItems={totalItems}
        columns={columns}
      />
    </Fragment>
  );
};
